module.exports = __webpack_public_path__ + "img/t2-c4.fbcd75ac.png";